import { useEffect, useState } from "react";
import { Drawer, Upload, Steps, Input, notification, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import DraftRoot from "./DraftRoot";
import { useDispatch, useSelector } from "react-redux";
import { partsReset, partsAdd } from "../../store/actions";
import Participant from "./Participant";
import ShortUniqueId from "short-unique-id";
import { Translate } from "../../translate";
import DraftCard from "./DraftCard";
import PreviewRoot from "../PreviewRoot";
import DateTime from "../DateTime";
import { getStore } from "../../utils/global";
import axios from "../../utils/axios";
import DragDrop from "../upload/DragDrop";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "react-query";

const uid = new ShortUniqueId({ length: 10 });

const DraftRoute = (props) => {
  const history = useHistory();
  const [upSteps, setUpSteps] = useState(0);
  const [fileInfo, setFileInfo] = useState(null);
  const parts = useSelector((state) => state.draft.parts); //Participants
  const [stamps, setStamps] = useState([]);
  const [page, setPage] = useState(1);
  const [name, setName] = useState("Draft name");
  const dispatch = useDispatch();
  const user = getStore("user");
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  const {
    data: draftsList,
    isLoading: draftsLoading,
    refetch,
  } = useQuery({
    queryKey: ["get_drafts_list", user.kdss_user],
    queryFn: () => axios.post("client/api/doc/template/list", {}, { showErrorMessage: true }),
    select: ({ data }) => data?.list || [],
  });

  const startTemplate = () => {
    history.push("/drafts/2/0/0");
  };

  const makeBox = (per) => {
    let box = document.createElement("div");
    let inside = document.createElement("div");
    box.style.height = per.height + "px";
    box.style.width = per.width + "px";
    box.style.background = per.color;
    box.style.border = "1px solid " + per.color;
    box.style.left = per.x1 + "px";
    box.style.bottom = per.y1 + "px";
    box.style.position = "absolute";
    box.className = "drop_box";
    inside.className = "drop_box_name";
    inside.style.width = per.boxwidth + "px";
    inside.style.overflowWrap = "break-word";
    inside.innerHTML = per.value ? per.value : per.drag_txt;
    box.appendChild(inside);
    if (per.unique_key === "signature") {
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per.username;
      box.appendChild(inside_name);
    }
    return page === per.page ? box : null;
  };

  useEffect(() => {
    if (upSteps > 2) {
      let container = document.querySelector(".document_watermark_container_dropable");
      container.innerHTML = "";
      stamps.map((per, i) => page === per.page && container.appendChild(makeBox(per)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const closeDrawer = () => {
    clearStates();
    history.push("/drafts/0/0/0");
  };

  const uploadFile = (file) => {
    setFileInfo(file);
    setUpSteps(upSteps + 1);
  };

  const addPart = () => {
    const colors = getStore("color");

    if (parts.length < 10) {
      let id = uid();
      dispatch(
        partsAdd({
          name: "Signer ",
          role: "SIGN",
          key: id,
          msisdn: "",
          email: "",
          user_id: id,
          color: colors[parts.length],
          bg_color: colors[parts.length],
          actionrole: "signer",
          can_sign: true,
          move_sign: false,
          coords: [],
          disable: false,
        }),
      );
    } else {
      notification.error({ message: "Max limit is 10.", duration: 3 });
    }
  };

  const changeName = (val, idx) => {
    let tmp = [...parts];
    tmp[idx].name = val;
  };

  const renderSteps = (step) => {
    switch (step) {
      case 0:
        return (
          <div className="step0_container relafull flex_center">
            <div className="upload_section flex_center">
              <div>
                <img src="/file-add.svg" alt="" />
              </div>
              <div className="upload_section_title">Drop Document here</div>
              <div className="upload_section_body">or Click here</div>
              <div className="second_circle" />
              <Upload.Dragger accept="application/pdf" multiple={false} className="upload_dragger absfull" beforeUpload={uploadFile} />
            </div>
          </div>
        );
      case 1:
        return (
          <div className="file_container">
            <div className="file_container_header">
              <div className="file_info_box">
                <div className="file_info_header"> {Translate[ln].Template.DraftInfo}</div>
                <div className="double_info">
                  <text>{Translate[ln].Template.DraftName}</text>
                  <Input value={name} onChange={(e) => setName(e.target.value)} />
                </div>
              </div>
              <div className="file_info_box">
                <div className="file_info_header">{Translate[ln].Template.SenderInfo} </div>
                <div className="double_info">
                  <text>{Translate[ln].Template.Name}</text>
                  <text>{user?.kdss_name}</text>
                </div>
                <div className="double_info">
                  <text>{Translate[ln].Template.MSISDN}</text>
                  <text>{user?.kdss_msisdn}</text>
                </div>
                <div className="double_info">
                  <text>{Translate[ln].Template.Email}</text>
                  <text>{user?.kdss_email}</text>
                </div>
              </div>
              <div className="file_info_box">
                <div className="file_info_header"> {Translate[ln].Template.FileInfo} </div>
                <div className="double_info">
                  <text>{Translate[ln].Template.FileName}</text>
                  <text>{fileInfo?.name}</text>
                </div>
                <div className="double_info">
                  <text>{Translate[ln].Template.FileSize}</text>
                  <text>{`${fileInfo?.size / 1000} kB`}</text>
                </div>

                <div className="double_info">
                  <text>{Translate[ln].Template.ModDate}</text>
                  <text>
                    <DateTime data={fileInfo?.lastModifiedDate?.toString()} />
                  </text>
                </div>
              </div>
              <div className="btn button_flex" bg_color="5" onClick={addPart}>
                {Translate[ln].Template.AddParticipants}
              </div>
            </div>
            <div className="template_participants">
              <div style={{ fontWeight: "600", fontSize: "24px" }}>{`${parts.length} ${parts.length === 1 ? "Participant" : "Participants"}`}</div>
              {parts?.map((item, idx) => (
                <Participant index={idx} key={item.key} onChange={(val) => changeName(val, idx)} />
              ))}
            </div>
          </div>
        );

      case 2:
        return <DragDrop file={fileInfo} parts={parts} setStamps={setStamps} stamps={stamps} hideTag={false} />;
      default:
        return (
          <div className="step1_container relafull">
            <div className="step1_detail">
              <div className="step1_user_detail" style={{ marginTop: 20 }}>
                <div className="step1_user_detail_title">{Translate[ln].NewDoc.Preview.Sender} </div>
                <div className="step1_user_detail_body">
                  <div className="user_dropdown_name">{user.kdss_name}</div>
                  <div className="user_dropdown_mobile">{user.kdss_msisdn}</div>
                  <div className="user_dropdown_email" color="1">
                    {user.kdss_email}
                  </div>
                </div>
              </div>
              <div className="parts_scroll_area">
                {parts?.map((per, i) => {
                  return (
                    <div key={i} className="step1_user_detail" style={{ marginTop: 20, overflow: "hidden" }}>
                      <div className="step1_user_detail_body" style={{ background: per.bg_color }}>
                        <div className="user_dropdown_name">{per.name}</div>
                        <div className="user_dropdown_mobile">{per.role}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="step3_body">
              <div className="absfull">
                <PreviewRoot
                  file={fileInfo}
                  onSuccess={() => {
                    let element = document.createElement("div");
                    let dropable = document.createElement("div");
                    dropable.className = "document_watermark_container_dropable";
                    element.className = "document_watermark_container";

                    stamps.map((per) => page === per.page && dropable.appendChild(makeBox(per)));

                    element.appendChild(dropable);

                    document.querySelector(".react-pdf__Page").appendChild(element);
                  }}
                  stamps={[]}
                  locked={true}
                  lockInputs={true}
                  pageChange={setPage}
                />
              </div>
            </div>
          </div>
        );
    }
  };

  const steps = [
    {
      title: "File upload",
      key: "FileUpload",
    },
    {
      title: "Set participants",
      key: "SetPart",
    },
    {
      title: "Add stamps",
      key: "AddStamps",
    },
    {
      title: "Preview",
      key: "Preview",
    },
  ];

  const clearStates = () => {
    dispatch(partsReset());
    setFileInfo(null);
    setUpSteps(0);
    setStamps([]);
    setPage(1);
    setName("Draft name");
  };

  const { mutate: createTemplate, isLoading: isCreating } = useMutation({
    mutationFn: async () => {
      // 1. Prepare and upload the file
      const formData = new FormData();
      formData.append("file", fileInfo);

      const fileRes = await axios.post(
        "client/api/doc/template/file/upload",
        formData,
        {
          formData: true,
        },
        { showErrorMessage: true },
      );

      if (!fileRes.success) throw new Error("File upload failed");

      // 2. Prepare the template body using the returned doc_id
      const body = {
        name: name,
        stamps: JSON.stringify(stamps),
        owner_id: user.id,
        signers: JSON.stringify(parts),
        signers_count: parts.length,
        doc_id: fileRes.data?.doc_id,
      };

      // 3. Create the template
      const templateRes = await axios.post("client/api/doc/template/create", body, { showErrorMessage: true, showSuccessMessage: true });
      if (!templateRes.success) throw new Error("Template creation failed");
    },
    onSuccess: ({ success }) => {
      if (success) {
        closeDrawer();
        refetch(); // Refetch the list
        clearStates();
      }
    },
  });

  const backhandler = () => {
    setUpSteps(upSteps - 1);
    if (upSteps === 1) {
      clearStates();
    }
  };

  const upHandler = () => {
    if (upSteps === 3) {
      createTemplate();
    }
    upSteps < 3 && setUpSteps(upSteps + 1);
  };

  const stepHandler = (step) => {
    if (step < upSteps) setUpSteps(step);
  };

  const renderTitle = () => {
    return (
      <>
        {upSteps > 0 && <Button onClick={backhandler}>{Translate[ln].Template.Prev}</Button>}
        <Steps current={upSteps} onChange={(e) => stepHandler(e)} responsive items={steps} />
        {upSteps !== 0 && (
          <Button onClick={upHandler} loading={isCreating}>
            {upSteps === 3 ? Translate[ln].Template.Save : Translate[ln].Template.Next}
          </Button>
        )}
      </>
    );
  };

  useEffect(() => {
    if (props.match.params.popfilter === "2") {
      clearStates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.popfilter]);

  return (
    <div className="templates">
      {props.match.params.popfilter === "1" && <DraftRoot params={props.match?.params} refetch={refetch} />}
      {draftsLoading && (
        <div className="loader">
          <LoadingOutlined />
        </div>
      )}
      {props.match.params.popfilter === "2" && (
        <Drawer
          className="custom_drawer"
          open={props.match.params.popfilter === "2"}
          onClose={closeDrawer}
          placement="bottom"
          height="100%"
          title={<div className="drawer_title">{renderTitle()}</div>}>
          {renderSteps(upSteps)}
        </Drawer>
      )}
      <div className="templates_map">
        <div className="template">
          <div className="template_create" onClick={startTemplate}>
            +
          </div>
        </div>
        {draftsList?.map((e, idx) => (
          <DraftCard data={e} key={idx} refetch={refetch} />
        ))}
      </div>
    </div>
  );
};

export default DraftRoute;
